<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
    >
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入手机号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="权限类型" prop="authType">
        <el-select
          v-model="queryParams.authType"
          placeholder="请选择权限类型"
          clearable
          filterable
        >
          <el-option
            v-for="item in CategoryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="需求类型" prop="demandType">
        <el-select
          v-model="queryParams.demandType"
          placeholder="请选择需求类型"
          clearable
          filterable
        >
          <el-option
            v-for="item in demandTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="买卖类型" prop="tradeType" label-width="140px">
        <el-radio-group
          v-model="queryParams.tradeType"
          size="small"
          class="isRuturn"
        >
          <el-radio style="margin-right: 10px" border label="1"
            >买服务</el-radio
          >
          <el-radio style="margin-right: 10px" border label="2"
            >卖服务</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="状态" prop="goodsStatus">
        <el-radio-group v-model="queryParams.goodsStatus">
          <el-radio
            style="margin-right: 10px"
            border
            v-for="dict in dict.type.status"
            :key="dict.value"
            :label="dict.value"
            >{{ dict.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item> -->

      <!-- <el-form-item label="禁止状态" prop="isForce">
        <el-radio-group v-model="queryParams.isForce">
          <el-radio
            border
            v-for="dict in dict.type.status"
            :key="dict.value"
            :label="dict.value"
            >{{ dict.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item> -->
      <el-form-item class="search">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8 mt10">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>

      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table
      v-loading="loading"
      :data="tableList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="发布人"
        align="center"
        prop="nickName"
        show-overflow-tooltip
      />
      <el-table-column
        label="需求名称"
        align="center"
        prop="name"
        show-overflow-tooltip
      />
      <el-table-column
        label="手机号"
        align="center"
        prop="phone"
        show-overflow-tooltip
      />
      <el-table-column
        label="价格(元)"
        align="center"
        prop="price"
        show-overflow-tooltip
      />
      <el-table-column label="买卖类型" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.tradeType == 1">买服务</span>
          <span v-if="scope.row.tradeType == 2">卖服务</span>
        </template>
      </el-table-column>
      <el-table-column
        label="权限类型"
        align="center"
        prop="authName"
        show-overflow-tooltip
      />
      <el-table-column
        label="需求类型"
        align="center"
        prop="demandName"
        show-overflow-tooltip
      />
      <el-table-column
        label="创建时间"
        align="center"
        prop="create_time"
        width="150"
      >
        <!-- <template slot-scope="scope">
          <span>{{ parseTime(scope.row.onsaleTime, "{y}-{m}-{d}") }}</span>
        </template> -->
      </el-table-column>
      <el-table-column
        label="状态"
        align="center"
        prop="status"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == 1" type="warning">待抢单</el-tag>
          <el-tag v-if="row.status == 2">抢单成功</el-tag>
          <el-tag v-if="row.status == 3">已成单</el-tag>
          <el-tag v-if="row.status == 4" type="success">已完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="320"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            circle
            type="text"
            icon="el-icon-search"
            @click="handlesee(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            v-if="
              scope.row.status == 1 &&
              (scope.row.userId == storeId || storeId == 0)
            "
            @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-thumb"
            v-if="scope.row.status == 1"
            @click="handleGrabbing(scope.row)"
            >抢单</el-button
          >
          <!-- 添加配饰 -->
          <el-button
            size="mini"
            type="text"
            icon="el-icon-document"
            @click="handlePeishi(scope.row)"
            >抢单情况</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            v-if="
              scope.row.status == 1 &&
              (scope.row.userId == storeId || storeId == 0)
            "
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改商品对话框 -->
    <el-drawer
      :title="title"
      :visible.sync="open"
      size="50%"
      append-to-body
      :wrapperClosable="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="130px"
        class="forms"
        :disabled="title == '详情'"
      >
        <el-form-item label="需求名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入需求名称" />
        </el-form-item>
        <el-form-item label="需求详情" prop="content">
          <editor v-model="form.content" :min-height="192" />
        </el-form-item>
        <el-form-item label="图片" prop="img">
          <el-upload
            :action="url"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :file-list="fileList"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            type="number"
            v-model="form.phone"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <el-form-item label="价格(元)" prop="price">
          <el-input
            type="number"
            v-model="form.price"
            placeholder="请输入价格"
          />
        </el-form-item>

        <el-form-item label="买卖类型" prop="tradeType">
          <el-radio-group
            v-model="form.tradeType"
            size="small"
            class="isRuturn"
          >
            <el-radio :label="'1'">买服务</el-radio>
            <el-radio :label="'2'">卖服务</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="权限类型" prop="authType">
          <el-select
            v-model="form.authType"
            placeholder="请选择权限类型"
            clearable
            filterable
          >
            <el-option
              v-for="item in CategoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="需求类型" prop="demandType">
          <el-select
            v-model="form.demandType"
            placeholder="请选择需求类型"
            clearable
            filterable
          >
            <el-option
              v-for="item in demandTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer" v-if="title != '详情'">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <!-- <el-button size="medium" type="primary" @click="anotherHandle"
          >保存并录入下一条</el-button
        > -->
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>
    <PopupFrame title="抢单情况" :dialogVisible.sync="openPopupFrame">
      <Accessory
        :data="taskData"
        :setId="setId"
        :parentUserId="parentUserId"
      ></Accessory>
    </PopupFrame>
  </div>
</template>
  
<script>
import $ from "jquery";
import {
  listTableCategory,
  delTable,
  addTable,
  updateTable,
  insertGrabbing,
} from "@/api/grabbing";
import { listTableCategory1 } from "@/api/authType";
import { listTableCategory2 } from "@/api/demandType";
import PopupFrame from "@/components/PopupFrame";
import Accessory from "./Accessory";
import config from "@/config/index";
export default {
  name: "Table",
  dicts: ["status"],
  components: { PopupFrame, Accessory },
  data() {
    return {
      url: config.apiUploadUrl,
      openPopupFrame: false,
      // 权限类型列表
      CategoryList: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 商品表格数据
      tableList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        authType: null,
        demandType: null,
        phone: null,
        name: null,
        price: null,
        tradeType: null,
        platformId: this.$route.query.platformId,
        grabbingId: this.$route.query.storeId,
        url: this.$route.query.url,
      },
      // 表单参数
      form: {
        id: null,
        authType: null,
        demandType: null,
        userId: this.$route.query.storeId,
        platformId: this.$route.query.platformId,
        phone: null,
        name: null,
        img: null,
        content: null,
        price: null,
        tradeType: null,
        userType: 2,
      },
      // 表单校验
      rules: {
        authType: [
          { required: true, message: "权限类型不能为空", trigger: "change" },
        ],
        demandType: [
          { required: true, message: "需求类型不能为空", trigger: "change" },
        ],
        name: [
          { required: true, message: "需求名称不能为空", trigger: "blur" },
        ],
        tradeType: [
          { required: true, message: "买卖类型不能为空", trigger: "change" },
        ],
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
        price: [{ required: true, message: "价格不能为空", trigger: "blur" }],
        onsaleTime: [
          { required: true, message: "上架时间不能为空", trigger: "blur" },
        ],
        integral: [
          { required: true, message: "积分不能为空", trigger: "blur" },
        ],
      },
      taskData: {},
      taskData2: {},
      setId: "",
      parentUserId: "",
      setId2: "",
      img: "",
      storeId: "",
      storeName: "",
      fileList: [],
      picList: [],
      demandTypeList: [],
      storePhone: "",
    };
  },
  created() {
    this.getStoreInfo();
    this.getList();
    this.getCategory();
    this.getCategory2();
    this.storeId = this.$route.query.storeId;
  },
  methods: {
    // 获取店铺信息
    getStoreInfo() {
      var that = this;
      $.ajax({
        type: "get",
        url: that.$route.query.url + "/pointsMall/storeInfo",
        data: { storeId: that.$route.query.storeId },
        success: function (res) {
          that.storePhone = res.data.telephone;
        },
      });
    },

    // 上传图片
    handleAvatarSuccess(res, file) {
      this.picList.push(res.data);
      console.log(this.picList, " this.picList");
      return false;
    },
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    handleRemove(file, fileList) {
      for (const i in this.picList) {
        if (this.picList[i] === file.url) {
          this.picList.splice(i, 1);
        }
        if (file.response != undefined) {
          if (this.picList[i] === file.response.picurl) {
            this.picList.splice(i, 1);
          }
        }
      }
    },
    /** 获取权限类型 下拉选 */
    async getCategory() {
      const res = await listTableCategory1({ pageNum: 1, pageSize: 999 });
      this.CategoryList = res.data.list;
    },
    /** 获取需求类型 下拉选 */
    async getCategory2() {
      const res = await listTableCategory2({ pageNum: 1, pageSize: 999 });
      this.demandTypeList = res.data.list;
    },
    /** 查询需求列表 */
    getList() {
      this.loading = true;
      listTableCategory(this.queryParams).then((response) => {
        this.tableList = response.data.list;
        console.log(this.tableList, "  this.tableList");
        this.total = response.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        authType: null,
        demandType: null,
        userId: this.$route.query.storeId,
        platformId: this.$route.query.platformId,
        phone: null,
        name: null,
        img: null,
        content: null,
        price: null,
        tradeType: null,
        userType: 2,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.fileList = [];
      this.picList = [];
      this.open = true;
      this.title = "添加需求";
    },
    /** 详情按钮操作 */
    handlesee(row) {
      this.reset();
      this.fileList = [];
      this.picList = [];
      this.open = true;
      this.title = "详情";
      this.form = Object.assign({}, row);
      if (row.img != "") {
        this.picList = row.img.split(",");
        this.picList.forEach((map) => {
          var url = map;
          this.fileList.push({ url });
        });
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.fileList = [];
      this.picList = [];
      this.open = true;
      this.title = "修改需求";
      this.form = Object.assign({}, row);
      if (row.img != "") {
        this.picList = row.img.split(",");
        this.picList.forEach((map) => {
          var url = map;
          this.fileList.push({ url });
        });
      }
    },
    // 抢单情况
    handlePeishi(row) {
      this.openPopupFrame = true;
      this.taskData = row;
      this.setId = this.taskData.id;
      this.parentUserId = this.taskData.userId;
    },
    /** 提交按钮 */
    submitForm() {
      console.log(this.form, "form");
      if (this.picList && Array.isArray(this.picList)) {
        this.form.img = this.picList.join(",");
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateTable(this.form).then((response) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.open = false;
              this.getList();
              this.reset();
              this.fileList = [];
              this.picList = [];
            });
          } else {
            addTable(this.form).then((response) => {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.open = false;
              this.getList();
              this.reset();
              this.fileList = [];
              this.picList = [];
            });
          }
        }
      });
    },
    // 保存并录入下一条
    anotherHandle() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateTable(this.form).then((response) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.getList();
              this.reset();
            });
          } else {
            addTable(this.form).then((response) => {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.getList();
              this.reset();
            });
          }
        }
      });
    },

    /** 抢单按钮操作 */
    handleGrabbing(row) {
      console.log(row);
      var that = this;
      if (row.authName == "所有用户" || row.authName == "店铺") {
        that
          .$confirm("是否确认抢单?", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(function () {
            console.log(that.storeId);
            return insertGrabbing({
              demandId: row.id,
              userId: that.storeId,
              userType: 2,
              phone: that.storePhone,
            });
          })
          .then(() => {
            that.$message({
              message: "抢单成功",
              type: "success",
            });
            that.getList();
            // 可以抢单
          });
      } else {
        // 不可以抢单
        that.$message({
          message: "暂无抢单权限",
          type: "warning",
        });
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm("是否确认删除该需求？", {
        type: "warning",
      })
        .then(function () {
          return delTable(ids);
        })
        .then(() => {
          this.getList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style  scoped>
.isRuturn /deep/ .el-radio__label {
  font-size: 14px;
}

/deep/ .el-drawer {
  overflow-y: auto;
}
</style>
  